/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountTransferWithdrawResponse,
  AccountTransferWithdraw: (params: vp.AccountTransferWithdrawRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountTransferWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAccountTransferWithdraw, setShouldAccountTransferWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountTransferWithdrawRequest>({
    DebitorClientAccountID: '',
    RecipientClientAccountID: '',
    RecipientClientAccountIDSplit: '',
    Amount: 0,
    ClientReferenceNumber: '',
    Notes: '',
    TransactionLabel: '',
    Currency: '',
  });
  const [response, setResponse] = useState<vp.AccountTransferWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    WithdrawTransactionID: '',
    AccountTransferID: '',
    AccountTransferIDs: {},
    WithdrawTransactionIDs: {},
  });

  useEffect(() => {
    if (!shouldAccountTransferWithdraw) return () => {};

    const PostAccountTransferWithdraw = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      // Remove RecipientClientAccountID or RecipientClientAccountIDSplit from params as both cant be passed
      const filteredParams = { ...params };
      if (params.RecipientClientAccountIDSplit !== '') {
        delete filteredParams.RecipientClientAccountID;
      } else {
        delete filteredParams.RecipientClientAccountIDSplit;
      }

      const res = await api.postAccountTransferWithdraw(filteredParams, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAccountTransferWithdraw) void PostAccountTransferWithdraw();
    setShouldAccountTransferWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldAccountTransferWithdraw]);

  return [
    response,
    (_params: vp.AccountTransferWithdrawRequest) => {
      setParams(_params);
      setShouldAccountTransferWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        WithdrawTransactionID: '',
        AccountTransferID: '',
        AccountTransferIDs: {},
        WithdrawTransactionIDs: {},
      });
      setShouldAccountTransferWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountTransferWithdraw);
